import MapoSingleContent from 'components/MapoAdministration/components/Content-Management/MapoSingleContent';

const ScreenMapoSingleContent = () => <MapoSingleContent />;

export default ScreenMapoSingleContent;
